import(/* webpackMode: "eager", webpackExports: ["PageEvents"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/events/__page__/PageEvents.tsx");
